require('@selectize/selectize');

export function applySelectize() {
  var options = {
    plugins: ['remove_button'],
    delimiter: ',',
    persist: false,
    create: function create(input) {
      return {
        value: input,
        text: input
      };
    }
  };
  $.each(['input#allowed_ip_addresses', 'input#allowed_reporting_ip_addresses', 'input#allowed_domains', 'input#blacklisted_domains', 'input#bins'], function (index, element) {
    $(element).selectize(options);
  });
}